module.exports = "https://r.nearpod.com/assets/media/image/whats_new_icon-4cd92143b14def865fb67f13ad9c0c32.svg";